<template>
  <div class="">
    <div class="row mb-3">
      <div class="col col-sm-6 pr-0">
        <input type="text" class="form-control" v-model="data.random_var" placeholder="variable name to store randomly picked value">
      </div>
      <div class="col col-sm-6 pl-0">
        <input type="text" class="form-control" v-model="data.list_var" placeholder="List name from which random value will be picked">
      </div>
    </div>
  </div>
</template>


<script type="text/javascript">

  export default {
    name: 'Random',
    props: {
      data: Object
    },
  }
</script>
